import { render, staticRenderFns } from "./healthPackageDetails.vue?vue&type=template&id=f421b3ee&scoped=true&"
import script from "./healthPackageDetails.vue?vue&type=script&lang=js&"
export * from "./healthPackageDetails.vue?vue&type=script&lang=js&"
import style0 from "./healthPackageDetails.vue?vue&type=style&index=0&id=f421b3ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f421b3ee",
  null
  
)

export default component.exports